(function( root, $, undefined ) {
	"use strict";

	$(function () {

		jQuery.fn.load = function(callback){
			$(window).on("load", callback);
		};

		var moodring = {

			touch: ("ontouchstart" in document.documentElement ? "touchstart" : "click"),

			initialWidth: $(window).width(),

			desktopVideo: false,

			init: function() {
				this.slider();
				this.pdp_thumb_slider();
				// this.homepage_video();
				// this.remove_empty_p_tags();
				// this.slider();
				// this.testimonial_slider();
				// this.video_pop_ups();
			},

			// homepage_video: function() {
			// 	if ($("body").hasClass("template-index")) {
			// 		var mobile_video = $("input[name='mobile-video']").data("src"),
			// 			desktop_video = $("input[name='desktop-video']").data("src"),
			// 			video = $(".hero__video--homepage-video");

			// 		if ($(window).width() > 590) {
			// 			video.attr("src", desktop_video);
			// 		} else {
			// 			// video.attr("src", mobile_video);
			// 			video.attr("src", mobile_video);
			// 		}

			// 		video[0].load();
			// 	}
			// },

			// remove_empty_p_tags: function() {
			// 	$("p").each(function() {
			// 		var $this = $(this);
			// 		if ($this.html().replace(/\s|&nbsp;/g, "").length == 0) {
			// 			$this.remove();
			// 		}
			// 	});
			// },

			slider: function() {
				var slidesToShow = ($(window).width() < 1200) ? 3 : 4;
				var showArrows = ($(window).width() < 1200) ? false : true;


				if ($(window).width() > 800) {
					$('.grid-carousel').slick({
						infinite: true,
						slidesToShow: 4,
						slidesToScroll: 4,
						arrows: showArrows,
						dots: true,
						prevArrow: '<button type="button" class="slick-prev"></button>',
						nextArrow: '<button type="button" class="slick-next"></button>',
						responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,								
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,								
							}
						}]					  
					});					
				}
			},


			pdp_thumb_slider: function () {
				$(".slider-thumb").slick({
					infinite: false,
					slidesToShow: 4,
					slidesToScroll: 4,
					dots: true,
					prevArrow: $('.slick__arrow--previous'),
					nextArrow: $('.slick__arrow--next')
					// autoplay: true
				})				
			}
			// testimonial_slider: function() {
			// 	$(".testimonial_slider").slick({
			// 		infinite: true,
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,
			// 		dots: true,
			// 		arrows: false,
			// 		autoplay: true
			// 	})
			// },

			// video_pop_ups: function () {
			// 	$("#video-post-1").magnificPopup({
			// 		items: {
			// 			src: $("#video-post-1").data("video-url")
			// 		},
			// 		type: "iframe",
			// 		iframe: {
			// 			markup: "<div class='mfp-iframe-scaler'>" +
			// 				"<div class='mfp-close'></div>" +
			// 				"<iframe class='mfp-iframe' frameborder='0' allowfullscreen></iframe>" +
			// 				"</div>",
			// 			patterns: {
			// 			    vimeo: {
			// 			      index: 'vimeo.com/',
			// 			      id: '/',
			// 			      src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
			// 			    },
			// 				youtube: {
			// 					index: "youtube.com/",
			// 					id: "v=",
			// 					src: "//www.youtube.com/embed/%id%?autoplay=1&muted=1&modestbranding=1&autohide=1&showinfo=0&controls=0&rel=0"
			// 				}
			// 			},
			// 			srcAction: "iframe_src",
			// 		}
			// 	});	

			// 	$("#video-post-2").magnificPopup({
			// 		items: {
			// 			src: $("#video-post-2").data("video-url")
			// 		},
			// 		type: "iframe",
			// 		iframe: {
			// 			markup: "<div class='mfp-iframe-scaler'>" +
			// 				"<div class='mfp-close'></div>" +
			// 				"<iframe class='mfp-iframe' frameborder='0' allowfullscreen></iframe>" +
			// 				"</div>",
			// 			patterns: {
			// 			    vimeo: {
			// 			      index: 'vimeo.com/',
			// 			      id: '/',
			// 			      src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
			// 			    },
			// 				youtube: {
			// 					index: "youtube.com/",
			// 					id: "v=",
			// 					src: "//www.youtube.com/embed/%id%?autoplay=1&muted=1&modestbranding=1&autohide=1&showinfo=0&controls=0&rel=0"
			// 				}
			// 			},
			// 			srcAction: "iframe_src",
			// 		}
			// 	});				

			// 	$("#video-post-3").magnificPopup({
			// 		items: {
			// 			src: $("#video-post-3").data("video-url")
			// 		},
			// 		type: "iframe",
			// 		iframe: {
			// 			markup: "<div class='mfp-iframe-scaler'>" +
			// 				"<div class='mfp-close'></div>" +
			// 				"<iframe class='mfp-iframe' frameborder='0' allowfullscreen></iframe>" +
			// 				"</div>",
			// 			patterns: {
			// 			    vimeo: {
			// 			      index: 'vimeo.com/',
			// 			      id: '/',
			// 			      src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
			// 			    },
			// 				youtube: {
			// 					index: "youtube.com/",
			// 					id: "v=",
			// 					src: "//www.youtube.com/embed/%id%?autoplay=1&muted=1&modestbranding=1&autohide=1&showinfo=0&controls=0&rel=0"
			// 				}
			// 			},
			// 			srcAction: "iframe_src",
			// 		}
			// 	});

			// 	$("#video-post-4").magnificPopup({
			// 		items: {
			// 			src: $("#video-post-4").data("video-url")
			// 		},
			// 		type: "iframe",
			// 		iframe: {
			// 			markup: "<div class='mfp-iframe-scaler'>" +
			// 				"<div class='mfp-close'></div>" +
			// 				"<iframe class='mfp-iframe' frameborder='0' allowfullscreen></iframe>" +
			// 				"</div>",
			// 			patterns: {
			// 			    vimeo: {
			// 			      index: 'vimeo.com/',
			// 			      id: '/',
			// 			      src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
			// 			    },
			// 				youtube: {
			// 					index: "youtube.com/",
			// 					id: "v=",
			// 					src: "//www.youtube.com/embed/%id%?autoplay=1&muted=1&modestbranding=1&autohide=1&showinfo=0&controls=0&rel=0"
			// 				}
			// 			},
			// 			srcAction: "iframe_src",
			// 		}
			// 	});																
			// }

		};

		moodring.init();

		$(window).resize(function() {
			// if (moodring.initialWidth < 590 && $(window).width() >= 590) {
			// 	if (moodring.desktopVideo == false) {
			// 		moodring.homepage_video();
			// 		moodring.desktopVideo = true;
			// 	}
			// }
		});

	});

} ( this, jQuery ));
